"use client";

import styles from "./Author.module.css";
import { CompanyLink } from "./CompanyLink";

type Props = {
  /** The author's job title */
  title?: string | null;
  /** The company name */
  company?: string | null;
  /** URL for the company link */
  url?: string | null;
  /** Display as company profile instead of person profile */
  isCompanyProfile?: boolean;
};

export const AuthorMeta = ({
  title,
  company,
  url,
  isCompanyProfile = false,
}: Props) => {
  // For company profiles, show company link if URL exists
  if (isCompanyProfile && url) {
    return (
      <div className={styles.authorMeta}>
        <CompanyLink
          company={company ?? url}
          url={url}
          testId="company-profile-link"
        />
      </div>
    );
  }

  // For person profiles, show title and company if they exist
  if ((title || company) && !isCompanyProfile) {
    return (
      <div className={styles.authorMeta}>
        {title && <span>{title}</span>}
        {title && company && <span>, </span>}
        {company &&
          (url ? (
            <CompanyLink company={company} url={url} testId="company-link" />
          ) : (
            <span>{company}</span>
          ))}
      </div>
    );
  }

  return null;
};
